/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Collect_Freight_HintInputs */

const vi_order_form_collect_freight_hint = /** @type {(inputs: Order_Form_Collect_Freight_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách thanh toán phí ship`)
};

/**

* @param {Order_Form_Collect_Freight_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_collect_freight_hint = /** @type {((inputs?: Order_Form_Collect_Freight_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Collect_Freight_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_collect_freight_hint(inputs)
});